module.exports = __webpack_public_path__ + "static/media/Home-BlueCircleMobile.c3f0d631.svg";